// Event photo gallery — real photos from Bangkok 2026 program
const NAVY = "#0E1B3D";
const GOLD = "#B8944D";

const SESSION_IMAGES = [
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_7e4e61dd-6912-4af3-ac17-762c1ac12aa9/artifacts/3oh98h9x_WhatsApp%20Image%202026-09-05%20at%2012.11.27.jpeg", caption: "Group session, main hall" },
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_7e4e61dd-6912-4af3-ac17-762c1ac12aa9/artifacts/y2w7zk3g_WhatsApp%20Image%202026-09-05%20at%2012.11.27%20%283%29.jpeg", caption: "Delegates in session" },
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_7e4e61dd-6912-4af3-ac17-762c1ac12aa9/artifacts/3yy51dxv_WhatsApp%20Image%202026-09-05%20at%2012.11.27%20%282%29.jpeg", caption: "Networking with international delegations" },
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_7e4e61dd-6912-4af3-ac17-762c1ac12aa9/artifacts/f62wp3vh_WhatsApp%20Image%202026-09-05%20at%2012.11.27%20%281%29.jpeg", caption: "Keynote at UN Conference Centre" },
];

const CULTURE_IMAGES = [
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_7e4e61dd-6912-4af3-ac17-762c1ac12aa9/artifacts/j83l3t23_WhatsApp%20Image%202026-09-05%20at%2012.11.27%20%284%29.jpeg", caption: "Delegates with national flags" },
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_7e4e61dd-6912-4af3-ac17-762c1ac12aa9/artifacts/uouv8qky_WhatsApp%20Image%202026-09-05%20at%2012.11.27%20%286%29.jpeg", caption: "Nations gathered under one roof" },
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_7e4e61dd-6912-4af3-ac17-762c1ac12aa9/artifacts/oiotym5c_WhatsApp%20Image%202026-09-05%20at%2012.11.27%20%287%29.jpeg", caption: "Cross-cultural exchange" },
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_7e4e61dd-6912-4af3-ac17-762c1ac12aa9/artifacts/jeluge2u_WhatsApp%20Image%202026-09-05%20at%2012.11.28%20%281%29.jpeg", caption: "Philippines delegation, Culture Day" },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      className="bg-white border-t"
      style={{ borderColor: "rgba(14,27,61,0.10)" }}
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-32">

        {/* Section 1: Sessions */}
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="gold-rule" />
            <p className="text-[10px] tracking-[0.4em] uppercase" style={{ color: GOLD }}>
              Bangkok 2026 · The Sessions
            </p>
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl leading-tight mb-4" style={{ color: NAVY }}>
            The work, in the room.
          </h2>
          <p className="text-base leading-relaxed" style={{ color: "#3A4256" }}>
            Three days at the United Nations Conference Centre. Delegates from more than sixty
            countries. Real dialogue, real leadership.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 lg:gap-6" data-testid="gallery-sessions-grid">
          <GalleryItem className="lg:col-span-7 lg:row-span-2 aspect-[4/5] lg:aspect-auto lg:h-[640px]" eyebrow="UN Conference Centre" {...SESSION_IMAGES[0]} />
          <GalleryItem className="lg:col-span-5 aspect-[4/3] lg:aspect-auto lg:h-[312px]" eyebrow="UN Conference Centre" {...SESSION_IMAGES[1]} />
          <GalleryItem className="lg:col-span-5 aspect-[4/3] lg:aspect-auto lg:h-[312px]" eyebrow="UN Conference Centre" {...SESSION_IMAGES[2]} />
          <GalleryItem className="md:col-span-2 lg:col-span-12 aspect-[16/6] lg:aspect-auto lg:h-[400px]" eyebrow="UN Conference Centre" {...SESSION_IMAGES[3]} />
        </div>

        {/* Divider */}
        <div className="my-24 lg:my-32 flex items-center gap-6">
          <span className="h-px flex-1" style={{ backgroundColor: "rgba(14,27,61,0.15)" }} />
          <p className="text-[10px] tracking-[0.4em] uppercase" style={{ color: GOLD }}>Culture Day</p>
          <span className="h-px flex-1" style={{ backgroundColor: "rgba(14,27,61,0.15)" }} />
        </div>

        {/* Section 2: Culture Day */}
        <div className="max-w-3xl mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl leading-tight mb-4" style={{ color: NAVY }}>
            Sixty nations. <span style={{ color: GOLD, fontStyle: "italic", fontWeight: 300 }}>One evening.</span>
          </h2>
          <p className="text-base leading-relaxed" style={{ color: "#3A4256" }}>
            Culture Day is when delegates shed the formality of the session halls and share
            what makes their homelands theirs — flags raised together, stories told across
            borders, friendships that outlast the program.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 lg:gap-6" data-testid="gallery-culture-grid">
          <GalleryItem className="md:col-span-2 lg:col-span-12 aspect-[16/9] lg:aspect-auto lg:h-[520px]" eyebrow="Culture Day · Bangkok" {...CULTURE_IMAGES[0]} />
          <GalleryItem className="lg:col-span-6 aspect-[4/3] lg:aspect-auto lg:h-[400px]" eyebrow="Culture Day · Bangkok" {...CULTURE_IMAGES[1]} />
          <GalleryItem className="lg:col-span-6 aspect-[4/3] lg:aspect-auto lg:h-[400px]" eyebrow="Culture Day · Bangkok" {...CULTURE_IMAGES[2]} />
          <GalleryItem className="md:col-span-2 lg:col-span-12 aspect-[16/8] lg:aspect-auto lg:h-[440px]" eyebrow="Philippines Delegation" {...CULTURE_IMAGES[3]} />
        </div>

        {/* Footer */}
        <div className="mt-20 flex flex-wrap items-center justify-between gap-6 pt-8 border-t" style={{ borderColor: "rgba(14,27,61,0.10)" }}>
          <div>
            <p className="text-[10px] tracking-[0.3em] uppercase mb-1" style={{ color: NAVY }}>Recognition</p>
            <p className="text-sm" style={{ color: "#3A4256" }}>
              Held at the United Nations Conference Centre · 330+ delegates · 60+ nations represented.
            </p>
          </div>
          <p className="text-xs" style={{ color: GOLD }}>Photography © GYP · Bangkok 2026</p>
        </div>
      </div>
    </section>
  );
}

const GalleryItem = ({ src, caption, eyebrow = "UN Conference Centre", className = "" }) => (
  <div className={`relative overflow-hidden group ${className}`}>
    <img
      src={src}
      alt={caption}
      className="absolute inset-0 w-full h-full object-cover img-editorial transition-transform duration-700 group-hover:scale-105"
    />
    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: "linear-gradient(to top, rgba(6,11,34,0.85), transparent 60%)" }} />
    <div className="absolute bottom-0 left-0 right-0 p-5 text-white translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500">
      <p className="text-[10px] tracking-[0.3em] uppercase mb-1" style={{ color: GOLD }}>{eyebrow}</p>
      <p className="text-sm font-medium">{caption}</p>
    </div>
  </div>
);
